import React from 'react';
import { Navbar } from '../components/Navbar';
import { RelatedFeatures } from '../components/RelatedFeatures';
import { Footer } from '../components/Footer';
import { NYCAccountingHero } from '../components/accounting-nyc/NYCAccountingHero';
import { NYCAccountingDataPreview } from '../components/accounting-nyc/NYCAccountingDataPreview';
import { AccountingFields } from '../components/accounting/AccountingFields';
import { NYCAccountingValueProps } from '../components/accounting-nyc/NYCAccountingValueProps';
import { AccountingWorkflow } from '../components/accounting/AccountingWorkflow';
import { NYCAccountingCityLinks } from '../components/accounting-nyc/NYCAccountingCityLinks';
import { NYCInternalLinks } from '../components/accounting-nyc/NYCInternalLinks';
import { NYCAccountingUseCases } from '../components/accounting-nyc/NYCAccountingUseCases';
import { NYCAccountingFAQ } from '../components/accounting-nyc/NYCAccountingFAQ';
import { NYCAccountingCta } from '../components/accounting-nyc/NYCAccountingCta';
import { DatabaseIcon, BookOpenIcon, ScaleIcon } from 'lucide-react';
// Custom related links for the accounting page
const accountingRelatedLinks = [{
  title: 'Local business owner finder',
  description: 'Find verified business owner contacts with emails and phones.',
  href: '#/owner-finder',
  cta: 'Explore feature',
  type: 'Feature',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Email sequencing',
  description: 'Launch multi-step email campaigns directly from the platform.',
  href: '#/email-sequencing',
  cta: 'Explore feature',
  type: 'Feature',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'How to book more meetings using free outreach tools',
  description: 'Proven templates and strategies for outbound email.',
  href: 'https://openmart.com/blogs/how-to-book-more-meetings-using-free-outreach-tools-and-proven-templates',
  cta: 'Read guide',
  type: 'Blog',
  color: 'blue' as const,
  icon: BookOpenIcon
}, {
  title: 'How to sell to local businesses',
  description: 'Strategies for targeting and closing local SMBs.',
  href: 'https://openmart.com/blogs/how-to-sell-to-local-business',
  cta: 'Read guide',
  type: 'Blog',
  color: 'blue' as const,
  icon: BookOpenIcon
}, {
  title: 'Using the Openmart API to fetch data',
  description: 'Integrate the Openmart API into your application.',
  href: 'https://openmart.com/product-tutorials/using-the-openmart-api-to-fetch-data',
  cta: 'Read tutorial',
  type: 'Tutorial',
  color: 'blue' as const,
  icon: BookOpenIcon
}, {
  title: 'Openmart vs ZoomInfo',
  description: 'Compare executive data coverage and pricing.',
  href: 'https://openmart.com/comparison/openmart-vs-zoominfo',
  cta: 'See comparison',
  type: 'Comparison',
  color: 'orange' as const,
  icon: ScaleIcon
}];
export function AccountingNYC() {
  return <div className="min-h-screen bg-white font-sans selection:bg-blue-100 selection:text-blue-900" data-id="element-6328">
      <Navbar data-id="element-6329" />
      <main data-id="element-6330">
        <NYCAccountingHero data-id="element-6331" />
        <NYCAccountingDataPreview data-id="element-6332" />
        <AccountingFields data-id="element-6333" />
        <NYCAccountingValueProps data-id="element-6334" />
        <AccountingWorkflow data-id="element-6335" />
        <NYCAccountingCityLinks data-id="element-6336" />
        <NYCInternalLinks data-id="element-6337" />
        <NYCAccountingUseCases data-id="element-6338" />
        <NYCAccountingFAQ data-id="element-6339" />
        <RelatedFeatures features={accountingRelatedLinks} data-id="element-6340" />
        <NYCAccountingCta data-id="element-6341" />
      </main>
      <Footer data-id="element-6342" />
    </div>;
}